import script from "./LiquidityScheduleTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiquidityScheduleTable.vue?vue&type=script&setup=true&lang=ts"

import "./LiquidityScheduleTable.vue?vue&type=style&index=0&id=3dbf4108&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbf4108"]])

export default __exports__